import { render, staticRenderFns } from "./CellarWine.vue?vue&type=template&id=5009a7cb&scoped=true"
import script from "./CellarWine.vue?vue&type=script&lang=js"
export * from "./CellarWine.vue?vue&type=script&lang=js"
import style0 from "./CellarWine.vue?vue&type=style&index=0&id=5009a7cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009a7cb",
  null
  
)

export default component.exports